<!--<h4>{{chartData.name}}</h4>-->
 <div>
    <canvas baseChart [chartType]="'doughnut'" [options]="doughnutOptions" [datasets]="chartData.datasets" [colors]="doughnutColors" [labels]="chartData.labels" [legend]="chartLagend" height="100"></canvas>
</div>